(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-audio-compare"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ELEMENT_NAME = 'td-audio-compare';

    const SELECTORS = {
      VOICE_CARD: '[data-td-voice-index]',
      VOICE_SELECT: '[data-td-voice-select]',
      VOICE_SELECT_TRIGGER: '[data-td-voice-select-trigger]',
      VOICE_SELECT_DROPDOWN: '[data-td-voice-select-dropdown]',
      VOICE_SELECT_OPTION: '[data-td-voice-option]',
      VOICE_SELECT_TRIGGER_LABEL: '[data-td-voice-select-trigger-label]',
      TRACK_CARD: '[data-td-track-index]',
      WAVE: '[data-td-wave]',
      PLAYER: '[data-td-player]',
      PLAY_BTN: '[data-td-play-btn]',
      SOUND_TITLE: '[data-td-player-sound-title]',
      SOUND_AUTHOR: '[data-td-player-sound-author]',
      MESSAGE: '[data-td-message]',
      TIMESTAMPS: '[data-td-timestamps]',
      TRACK_TIMER: '[data-td-track-timer]',
      TRACK_BTN_LABEL: '[data-td-track-btn-label]',
      TRACK_BTN_LABEL_MOBILE: '[data-td-track-btn-label-mobile]',
      TRACK_BTN_TITLE_MOBILE: '[data-td-track-btn-title-mobile]',
      TRACK_CARD_TITLE: '.td-audio-compare__track-card-title',
      TRACK_CARD_NOTE: '.td-audio-compare__track-card-note',
      TRACK_CARD_IMAGE_WRAP: '.td-audio-compare__track-card-image-wrap',
      PROGRESS_TRACK: '[data-td-progress-track]',
      AUDIO_DATA: '[data-td-audio-data]',
      WAVE_WRAP: '[data-td-wave-wrap]',
      WAVE_LOADING: '[data-td-wave-loading]',
    };

    const ACTIVE_VOICE_CLASS = 'td-audio-compare__voice-card--active';
    const ACTIVE_TRACK_CLASS = 'td-audio-compare__track-card--active';
    const BREAKPOINT_PX = 990;
    const WAVE_HEIGHT_MOBILE = 24;
    const WAVE_HEIGHT_DESKTOP = 44;
    const LOADING_INDICATOR_DELAY_MS = 260;

    const loadWaveSurfer = (scriptSource) => {
      if (!scriptSource) {
        return Promise.reject(new Error('WaveSurfer source is missing.'));
      }

      if (window.WaveSurfer) {
        return Promise.resolve(window.WaveSurfer);
      }

      if (window.__tdWaveSurferPromise) {
        return window.__tdWaveSurferPromise;
      }

      window.__tdWaveSurferPromise = new Promise((resolve, reject) => {
        const scriptElement = document.createElement('script');
        scriptElement.src = scriptSource;
        scriptElement.async = true;

        scriptElement.onload = () => {
          if (window.WaveSurfer) {
            resolve(window.WaveSurfer);
            return;
          }
          reject(new Error('WaveSurfer failed to initialize.'));
        };

        scriptElement.onerror = () => {
          reject(new Error('WaveSurfer failed to load.'));
        };

        document.head.appendChild(scriptElement);
      });

      return window.__tdWaveSurferPromise.catch((error) => {
        window.__tdWaveSurferPromise = null;
        throw error;
      });
    };

    class TDAudioCompare extends HTMLElement {
      constructor() {
        super();
        this.activeVoiceIndex = 0;
        this.activeTrackIndex = 0;
        this.waveSurfer = null;
        this.waveSubscriptions = [];
        this.isPlaying = false;
        this.isReady = false;
        this.setupToken = null;
        this.groupData = [];
        this.shouldAutoplayOnReady = false;
        this.loadingStateTimer = null;
        this.audioRenderCache = new Map();
        this.lastRequestedAudioUrl = '';
        this.lastLoadedAudioUrl = '';

        this.isScrubbing = false;
        this.wasPlayingBeforeScrub = false;
        this.resizeMediaQuery = null;

        this.handleVoiceClick = this.handleVoiceClick.bind(this);
        this.handleVoiceSelectChange = this.handleVoiceSelectChange.bind(this);
        this.handleVoiceSelectTriggerClick = this.handleVoiceSelectTriggerClick.bind(this);
        this.handleVoiceSelectOptionClick = this.handleVoiceSelectOptionClick.bind(this);
        this.handleVoiceSelectOptionKeydown = this.handleVoiceSelectOptionKeydown.bind(this);
        this.handleVoiceSelectClickOutside = this.handleVoiceSelectClickOutside.bind(this);
        this.handleVoiceSelectEscape = this.handleVoiceSelectEscape.bind(this);
        this.handleWaveResize = this.handleWaveResize.bind(this);
        this.handleTrackClick = this.handleTrackClick.bind(this);
        this.handlePlayClick = this.handlePlayClick.bind(this);
        this.handleScrubStart = this.handleScrubStart.bind(this);
        this.handleScrubMove = this.handleScrubMove.bind(this);
        this.handleScrubEnd = this.handleScrubEnd.bind(this);
        this.handleProgressTrackKeydown = this.handleProgressTrackKeydown.bind(this);
      }

      connectedCallback() {
        this.cacheElements();
        this.parseAudioData();

        if (!this.trackCards.length || !this.waveContainer || !this.groupData.length) {
          return;
        }

        const activeVoiceCard = this.voiceCards.find((c) => c.classList.contains(ACTIVE_VOICE_CLASS));
        if (activeVoiceCard) {
          this.activeVoiceIndex = parseInt(activeVoiceCard.dataset.tdVoiceIndex, 10);
        } else if (this.voiceSelect) {
          this.activeVoiceIndex = parseInt(this.voiceSelect.value, 10);
        } else {
          this.activeVoiceIndex = 0;
        }

        this.updateTrackCardsContent();
        this.updatePlayerInfo();
        this.bindEvents();
        this.initWaveSurfer();
      }

      disconnectedCallback() {
        this.closeVoiceSelectDropdown();
        this.unbindEvents();
        this.setupToken = null;
        this.destroyWaveSurfer();
        this.audioRenderCache.clear();
      }

      cacheElements() {
        this.voiceCards = Array.from(this.querySelectorAll(SELECTORS.VOICE_CARD));
        this.voiceSelect = this.querySelector(SELECTORS.VOICE_SELECT);
        this.voiceSelectTrigger = this.querySelector(SELECTORS.VOICE_SELECT_TRIGGER);
        this.voiceSelectDropdown = this.querySelector(SELECTORS.VOICE_SELECT_DROPDOWN);
        this.trackCards = Array.from(this.querySelectorAll(SELECTORS.TRACK_CARD));
        this.playerEl = this.querySelector(SELECTORS.PLAYER);
        this.waveContainer = this.querySelector(SELECTORS.WAVE);
        this.playBtn = this.querySelector(SELECTORS.PLAY_BTN);
        this.soundTitleEl = this.querySelector(SELECTORS.SOUND_TITLE);
        this.soundAuthorEl = this.querySelector(SELECTORS.SOUND_AUTHOR);
        this.messageEl = this.querySelector(SELECTORS.MESSAGE);
        this.progressTrack = this.querySelector(SELECTORS.PROGRESS_TRACK);
        this.timestampsContainer = this.querySelector(SELECTORS.TIMESTAMPS);
        this.trackTimerEls = this.querySelectorAll(SELECTORS.TRACK_TIMER);
        this.waveWrap = this.querySelector(SELECTORS.WAVE_WRAP);
      }

      parseAudioData() {
        const dataEl = this.querySelector(SELECTORS.AUDIO_DATA);
        if (!dataEl) return;

        try {
          this.groupData = JSON.parse(dataEl.textContent);
        } catch (e) {
          this.groupData = [];
        }
      }

      bindEvents() {
        this.voiceCards.forEach((card) => {
          card.addEventListener('click', this.handleVoiceClick);
        });

        if (this.voiceSelect) {
          this.voiceSelect.addEventListener('change', this.handleVoiceSelectChange);
        }

        if (this.voiceSelectTrigger) {
          this.voiceSelectTrigger.addEventListener('click', this.handleVoiceSelectTriggerClick);
        }

        if (this.voiceSelectDropdown) {
          this.voiceSelectDropdown.querySelectorAll(SELECTORS.VOICE_SELECT_OPTION).forEach((opt) => {
            opt.addEventListener('click', this.handleVoiceSelectOptionClick);
            opt.addEventListener('keydown', this.handleVoiceSelectOptionKeydown);
          });
        }

        this.resizeMediaQuery = window.matchMedia(`(min-width: ${BREAKPOINT_PX}px)`);
        this.resizeMediaQuery.addEventListener('change', this.handleWaveResize);

        this.trackCards.forEach((card) => {
          card.addEventListener('click', this.handleTrackClick);
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', this.handlePlayClick);
        }

        if (this.progressTrack) {
          this.progressTrack.addEventListener('pointerdown', this.handleScrubStart);
          this.progressTrack.addEventListener('keydown', this.handleProgressTrackKeydown);
        }
      }

      unbindEvents() {
        this.voiceCards.forEach((card) => {
          card.removeEventListener('click', this.handleVoiceClick);
        });

        if (this.voiceSelect) {
          this.voiceSelect.removeEventListener('change', this.handleVoiceSelectChange);
        }

        if (this.voiceSelectTrigger) {
          this.voiceSelectTrigger.removeEventListener('click', this.handleVoiceSelectTriggerClick);
        }

        if (this.voiceSelectDropdown) {
          this.voiceSelectDropdown.querySelectorAll(SELECTORS.VOICE_SELECT_OPTION).forEach((opt) => {
            opt.removeEventListener('click', this.handleVoiceSelectOptionClick);
            opt.removeEventListener('keydown', this.handleVoiceSelectOptionKeydown);
          });
        }

        document.removeEventListener('click', this.handleVoiceSelectClickOutside);

        if (this.resizeMediaQuery) {
          this.resizeMediaQuery.removeEventListener('change', this.handleWaveResize);
          this.resizeMediaQuery = null;
        }

        this.trackCards.forEach((card) => {
          card.removeEventListener('click', this.handleTrackClick);
        });

        if (this.playBtn) {
          this.playBtn.removeEventListener('click', this.handlePlayClick);
        }

        if (this.progressTrack) {
          this.progressTrack.removeEventListener('pointerdown', this.handleScrubStart);
          this.progressTrack.removeEventListener('keydown', this.handleProgressTrackKeydown);
        }

        document.removeEventListener('pointermove', this.handleScrubMove);
        document.removeEventListener('pointerup', this.handleScrubEnd);
      }

      /* ---- Voice selection ---- */

      handleVoiceClick(event) {
        const card = event.currentTarget;
        const index = parseInt(card.dataset.tdVoiceIndex, 10);
        this.selectVoice(index);
      }

      handleVoiceSelectChange() {
        const index = parseInt(this.voiceSelect.value, 10);
        this.selectVoice(index);
      }

      handleVoiceSelectTriggerClick(e) {
        e.stopPropagation();
        const isOpen = this.voiceSelectTrigger.getAttribute('aria-expanded') === 'true';
        this.voiceSelectTrigger.setAttribute('aria-expanded', String(!isOpen));
        this.voiceSelectDropdown.hidden = isOpen;

        if (!isOpen) {
          document.addEventListener('click', this.handleVoiceSelectClickOutside);
          document.addEventListener('keydown', this.handleVoiceSelectEscape);
        } else {
          document.removeEventListener('click', this.handleVoiceSelectClickOutside);
          document.removeEventListener('keydown', this.handleVoiceSelectEscape);
        }
      }

      handleVoiceSelectEscape(e) {
        if (e.key === 'Escape') {
          this.closeVoiceSelectDropdown();
        }
      }

      handleVoiceSelectClickOutside(e) {
        if (
          this.voiceSelectTrigger &&
          this.voiceSelectDropdown &&
          !this.voiceSelectTrigger.contains(e.target) &&
          !this.voiceSelectDropdown.contains(e.target)
        ) {
          this.closeVoiceSelectDropdown();
        }
      }

      closeVoiceSelectDropdown() {
        if (this.voiceSelectTrigger) {
          this.voiceSelectTrigger.setAttribute('aria-expanded', 'false');
        }
        if (this.voiceSelectDropdown) {
          this.voiceSelectDropdown.hidden = true;
        }
        document.removeEventListener('click', this.handleVoiceSelectClickOutside);
        document.removeEventListener('keydown', this.handleVoiceSelectEscape);
      }

      handleVoiceSelectOptionKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (e.currentTarget && typeof e.currentTarget.click === 'function') {
            e.currentTarget.click();
          }
        }
      }

      handleVoiceSelectOptionClick(e) {
        const option = e.currentTarget;
        const index = parseInt(option.dataset.tdVoiceOption, 10);
        if (this.voiceSelect) {
          this.voiceSelect.value = String(index);
          this.voiceSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        this.updateVoiceSelectDisplay(index);
        this.closeVoiceSelectDropdown();
      }

      updateVoiceSelectDisplay(index) {
        if (!this.voiceSelectTrigger || !this.voiceSelectDropdown) return;

        const option = this.voiceSelectDropdown.querySelector(
          `[data-td-voice-option="${index}"]`
        );
        if (!option) return;

        const imageUrl = option.dataset.tdVoiceImage || '';
        const labelSpan = option.querySelector('.td-audio-compare__voices-select-option-label');
        const title = labelSpan ? labelSpan.textContent : option.dataset.tdVoiceTitle || '';

        const imageWrap = this.voiceSelectTrigger.querySelector(
          '.td-audio-compare__voices-select-trigger-image'
        );
        const labelEl = this.voiceSelectTrigger.querySelector(
          SELECTORS.VOICE_SELECT_TRIGGER_LABEL
        );

        if (imageWrap) {
          imageWrap.replaceChildren();
          if (imageUrl) {
            const img = document.createElement('img');
            img.className = 'td-audio-compare__voices-select-trigger-img';
            img.src = imageUrl;
            img.alt = '';
            img.width = 40;
            img.height = 40;
            imageWrap.appendChild(img);
          } else {
            const tpl = this.querySelector('#td-ac-tpl-voice-placeholder');
            if (tpl?.content) imageWrap.appendChild(tpl.content.cloneNode(true));
          }
        }

        if (labelEl) {
          labelEl.textContent = title;
        }
      }

      selectVoice(index) {
        if (index === this.activeVoiceIndex) {
          return;
        }

        this.activeVoiceIndex = index;
        this.activeTrackIndex = 0;

        this.updateVoiceActiveState();
        this.updateTrackCardsContent();
        this.updateTrackActiveState();
        this.updatePlayerInfo();
        this.loadAndPlay(true);
      }

      updateVoiceActiveState() {
        this.voiceCards.forEach((card) => {
          const index = parseInt(card.dataset.tdVoiceIndex, 10);
          const isActive = index === this.activeVoiceIndex;
          card.classList.toggle(ACTIVE_VOICE_CLASS, isActive);
          card.setAttribute('aria-checked', String(isActive));
        });

        if (this.voiceSelect) {
          this.voiceSelect.value = String(this.activeVoiceIndex);
        }

        if (this.voiceSelectTrigger) {
          this.updateVoiceSelectDisplay(this.activeVoiceIndex);
        }
      }

      /* ---- Track selection ---- */
      handleTrackClick(event) {
        const card = event.currentTarget;
        const index = parseInt(card.dataset.tdTrackIndex, 10);

        if (index === this.activeTrackIndex) {
          if (!this.isReady) {
            this.loadAndPlay(true);
            return;
          }
          this.handlePlayClick();
          return;
        }

        this.activeTrackIndex = index;

        this.updateTrackActiveState();
        this.updatePlayerInfo();
        this.loadAndPlay(true);
      }

      updateTrackActiveState() {
        this.trackCards.forEach((card, i) => {
          const isActive = i === this.activeTrackIndex;
          card.classList.toggle(ACTIVE_TRACK_CLASS, isActive);
          card.setAttribute('aria-checked', String(isActive));
        });

        this.updateTrackButtonLabels();
      }

      /**
       * Updates track card content (title, image) to match the active voice's track data.
       * Hides cards for tracks that don't exist in the current voice.
       */
      updateTrackCardsContent() {
        const voice = this.groupData[this.activeVoiceIndex];
        if (!voice || !voice.tracks) return;

        const hasAudio = (t) => t && typeof t.audio === 'string' && t.audio.trim().length > 0;
        const isVisibleTrack = (t) => hasAudio(t);

        const firstVisible = voice.tracks.findIndex(isVisibleTrack);
        const currentVisible = isVisibleTrack(voice.tracks[this.activeTrackIndex]);

        if (firstVisible >= 0 && !currentVisible) {
          this.activeTrackIndex = firstVisible;
          this.updateTrackActiveState();
        }

        this.trackCards.forEach((card, i) => {
          const track = voice.tracks[i];
          if (!track || !isVisibleTrack(track)) {
            card.hidden = true;
            return;
          }
          card.hidden = false;

          const title = (track.title || '').trim();
          const note = (track.note || '').trim();
          const titleEl = card.querySelector(SELECTORS.TRACK_CARD_TITLE);
          if (titleEl) {
            if (track.logo) {
              const logoWrap = titleEl.querySelector('.td-audio-compare__track-card-title-logo');
              const textSpan = titleEl.querySelector('.td-audio-compare__track-card-title-text');
              const noteSpan = titleEl.querySelector(SELECTORS.TRACK_CARD_NOTE);
              if (logoWrap && textSpan) {
                const logoImg = logoWrap.querySelector('img');
                if (logoImg) logoImg.src = track.logo;
                textSpan.textContent = title;
                if (noteSpan) {
                  noteSpan.textContent = note;
                  noteSpan.hidden = !note;
                }
              } else {
                titleEl.replaceChildren();
                const logoSpan = document.createElement('span');
                logoSpan.className = 'td-audio-compare__track-card-title-logo';
                const logoImg = document.createElement('img');
                logoImg.className = 'td-audio-compare__track-card-title-logo-img';
                logoImg.src = track.logo;
                logoImg.alt = '';
                logoImg.loading = 'lazy';
                logoImg.width = 200;
                logoSpan.appendChild(logoImg);
                const textSpanNew = document.createElement('span');
                textSpanNew.className = 'td-audio-compare__track-card-title-text td-audio-compare__track-card-title-text--hide-on-desktop';
                textSpanNew.textContent = title;
                const noteSpanNew = document.createElement('span');
                noteSpanNew.className = 'td-audio-compare__track-card-note';
                noteSpanNew.textContent = note;
                noteSpanNew.hidden = !note;
                titleEl.appendChild(logoSpan);
                titleEl.appendChild(textSpanNew);
                titleEl.appendChild(noteSpanNew);
              }
            } else {
              let textSpan = titleEl.querySelector('.td-audio-compare__track-card-title-text');
              let noteSpan = titleEl.querySelector(SELECTORS.TRACK_CARD_NOTE);

              if (!textSpan) {
                textSpan = document.createElement('span');
                textSpan.className = 'td-audio-compare__track-card-title-text';
                titleEl.appendChild(textSpan);
              }

              if (!noteSpan) {
                noteSpan = document.createElement('span');
                noteSpan.className = 'td-audio-compare__track-card-note';
                titleEl.appendChild(noteSpan);
              }

              textSpan.textContent = title;
              noteSpan.textContent = note;
              noteSpan.hidden = !note;
            }
          }

          card.setAttribute('aria-label', title);
          card.dataset.tdTrackTitle = title;
          card.dataset.tdTrackNote = note;

          const mobileTitle = card.querySelector(SELECTORS.TRACK_BTN_TITLE_MOBILE);
          if (mobileTitle) {
            mobileTitle.textContent = title;
          }

          const imageWrap = card.querySelector(SELECTORS.TRACK_CARD_IMAGE_WRAP);
          if (imageWrap) {
            const isActive = i === this.activeTrackIndex;
            const labelContent = isActive && this.isPlaying ? 'PLAYING NOW' : 'PLAY';

            imageWrap.replaceChildren();
            if (track.image) {
              const img = document.createElement('img');
              img.className = 'td-audio-compare__track-card-image';
              img.src = track.image;
              img.alt = '';
              img.loading = 'lazy';
              img.width = 200;
              img.height = 200;
              imageWrap.appendChild(img);
            } else {
              const tpl = this.querySelector('#td-ac-tpl-track-placeholder');
              if (tpl?.content) imageWrap.appendChild(tpl.content.cloneNode(true));
            }
            const labelSpan = document.createElement('span');
            labelSpan.className = 'td-audio-compare__track-card-btn-label';
            labelSpan.dataset.tdTrackBtnLabelMobile = '';
            labelSpan.textContent = labelContent;
            imageWrap.appendChild(labelSpan);
          }
        });

        this.updateTrackActiveState();
      }

      /* ---- Player info ---- */
      updatePlayerInfo() {
        const voice = this.groupData[this.activeVoiceIndex];
        const track = this.getActiveTrackData();
        if (!voice) return;

        if (this.soundTitleEl) {
          this.soundTitleEl.textContent = voice.voiceTitle || '';
        }

        if (this.soundAuthorEl) {
          this.soundAuthorEl.textContent = track && track.title ? 'ON ' + track.title : '';
        }
      }

      /* ---- Audio URL + timestamp resolution ---- */
      getActiveTrackData() {
        const voice = this.groupData[this.activeVoiceIndex];
        if (!voice || !voice.tracks) return null;
        return voice.tracks[this.activeTrackIndex] || null;
      }

      getActiveAudioUrl() {
        const track = this.getActiveTrackData();
        return track && typeof track.audio === 'string' ? track.audio.trim() : '';
      }

      getActiveTimestamps() {
        const voice = this.groupData[this.activeVoiceIndex];
        return voice ? (voice.timestamps || []) : [];
      }

      /* ---- WaveSurfer lifecycle ---- */
      async initWaveSurfer() {
        const setupToken = Symbol('tdAudioCompareSetup');
        this.setupToken = setupToken;

        try {
          const scriptSource = this.dataset.tdWavesurferSrc;
          const WS = await loadWaveSurfer(scriptSource);

          if (!this.isConnected || this.setupToken !== setupToken || !this.waveContainer) {
            return;
          }

          this.WaveSurferLib = WS;
          this.createInstance();
        } catch (error) {
          this.showMessage('Unable to load audio player.');
        }
      }

      createInstance() {
        const audioUrl = this.getActiveAudioUrl();
        if (!audioUrl) {
          this.clearLoadingStateTimer();
          this.setLoadingState(false);
          this.setWaveReadyState(false);
          this.shouldAutoplayOnReady = false;
          this.showMessage('No audio file available for this selection.');
          if (this.playBtn) {
            this.playBtn.disabled = true;
          }
          return;
        }

        this.clearMessage();
        this.isReady = false;
        this.clearLoadingStateTimer();
        this.setWaveReadyState(false);
        this.setLoadingState(false);

        if (this.playBtn) {
          this.playBtn.disabled = true;
        }

        if (!this.waveSurfer) {
          const waveHeight = window.innerWidth >= BREAKPOINT_PX ? WAVE_HEIGHT_DESKTOP : WAVE_HEIGHT_MOBILE;

          this.waveSurfer = this.WaveSurferLib.create({
            container: this.waveContainer,
            waveColor: this.getComputedVar('--td-ac-track-bar', '#8f93a0'),
            progressColor: this.getComputedVar('--td-ac-track-bar-progress', '#ef383e'),
            cursorColor: 'transparent',
            cursorWidth: 0,
            height: waveHeight,
            barWidth: 2,
            barGap: 1,
            barRadius: 2,
            normalize: true,
            interact: false,
          });

          this.registerWaveEvents();
        }

        // If the same audio is already loaded, avoid a reload and just reset/play.
        if (audioUrl === this.lastLoadedAudioUrl && this.isReady) {
          this.clearLoadingStateTimer();
          this.setWaveReadyState(true);
          this.setLoadingState(false);
          this.updateProgress(0);
          this.renderTimestamps();
          this.waveSurfer.seekTo(0);

          if (this.shouldAutoplayOnReady) {
            this.safePlay();
          } else {
            this.waveSurfer.pause();
            this.setPlayingUI(false);
          }

          this.shouldAutoplayOnReady = false;

          if (this.playBtn) {
            this.playBtn.disabled = false;
          }

          return;
        }

        const cachedRender = this.audioRenderCache.get(audioUrl);
        if (cachedRender) {
          this.clearLoadingStateTimer();
          this.setLoadingState(false);
        } else {
          this.loadingStateTimer = window.setTimeout(() => {
            this.loadingStateTimer = null;
            this.setLoadingState(true);
          }, LOADING_INDICATOR_DELAY_MS);
        }

        this.lastRequestedAudioUrl = audioUrl;

        if (cachedRender) {
          this.waveSurfer.load(audioUrl, cachedRender.peaks, cachedRender.duration);
        } else {
          this.waveSurfer.load(audioUrl);
        }
      }

      registerWaveEvents() {
        if (!this.waveSurfer) return;

        const handleReady = () => {
          const currentAudioUrl = this.lastRequestedAudioUrl;

          this.isReady = true;
          this.clearLoadingStateTimer();
          this.setWaveReadyState(true);
          this.setLoadingState(false);
          this.lastLoadedAudioUrl = currentAudioUrl;

          if (this.playBtn) {
            this.playBtn.disabled = false;
          }

          this.updateProgress(0);
          this.renderTimestamps();

          if (currentAudioUrl && !this.audioRenderCache.has(currentAudioUrl)) {
            try {
              this.audioRenderCache.set(currentAudioUrl, {
                peaks: this.waveSurfer.exportPeaks(),
                duration: this.waveSurfer.getDuration(),
              });
            } catch (_) {}
          }

          if (this.shouldAutoplayOnReady) {
            this.safePlay();
          } else {
            this.setPlayingUI(false);
          }

          this.shouldAutoplayOnReady = false;
        };

        const handlePlay = () => {
          this.isPlaying = true;
          this.setPlayingUI(true);
        };

        const handlePause = () => {
          this.isPlaying = false;
          this.setPlayingUI(false);
        };

        const handleTimeUpdate = (currentTime) => {
          if (this.isScrubbing) return;
          this.updateProgress(currentTime);
        };

        const handleFinish = () => {
          this.isPlaying = false;
          this.setPlayingUI(false);
          this.updateProgress(this.waveSurfer ? this.waveSurfer.getDuration() : 0);
        };

        const handleError = () => {
          this.clearLoadingStateTimer();
          this.setWaveReadyState(false);
          this.setLoadingState(false);
          this.shouldAutoplayOnReady = false;
          this.showMessage('Unable to load audio file.');
          this.isReady = false;

          if (this.playBtn) {
            this.playBtn.disabled = true;
          }
        };

        const subscriptions = [
          this.waveSurfer.on('ready', handleReady),
          this.waveSurfer.on('play', handlePlay),
          this.waveSurfer.on('pause', handlePause),
          this.waveSurfer.on('timeupdate', handleTimeUpdate),
          this.waveSurfer.on('finish', handleFinish),
          this.waveSurfer.on('error', handleError),
        ];

        this.waveSubscriptions = subscriptions.filter(
          (unsub) => typeof unsub === 'function'
        );
      }

      destroyWaveSurfer() {
        this.clearLoadingStateTimer();
        this.waveSubscriptions.forEach((unsub) => unsub());
        this.waveSubscriptions = [];

        if (this.waveSurfer) {
          this.waveSurfer.destroy();
          this.waveSurfer = null;
        }

        this.setWaveReadyState(false);
        this.setLoadingState(false);
        this.isReady = false;
        this.isPlaying = false;
        this.lastRequestedAudioUrl = '';
        this.lastLoadedAudioUrl = '';
        this.updateTrackButtonLabels();
        this.updateProgress(0);
      }

      updateTrackButtonLabels() {
        this.trackCards.forEach((card, i) => {
          const isTrackPlaying = i === this.activeTrackIndex && this.isPlaying;
          const label = card.querySelector(SELECTORS.TRACK_BTN_LABEL);
          const mobileLabel = card.querySelector(SELECTORS.TRACK_BTN_LABEL_MOBILE);

          card.dataset.tdTrackPlaying = String(isTrackPlaying);

          if (label) {
            label.textContent = isTrackPlaying ? 'PLAYING' : 'PLAY';
          }

          if (mobileLabel) {
            mobileLabel.textContent = isTrackPlaying ? 'PLAYING NOW' : 'PLAY';
          }
        });
      }

      clearLoadingStateTimer() {
        if (this.loadingStateTimer) {
          clearTimeout(this.loadingStateTimer);
          this.loadingStateTimer = null;
        }
      }

      setWaveReadyState(ready) {
        if (!this.waveWrap) return;
        this.waveWrap.classList.toggle('td-audio-compare__wave-wrap--ready', !!ready);
      }

      setLoadingState(loading) {
        if (!this.waveWrap) return;
        this.waveWrap.classList.toggle('td-audio-compare__wave-wrap--loading', !!loading);
        const loadingEl = this.querySelector(SELECTORS.WAVE_LOADING);
        if (loadingEl) {
          loadingEl.setAttribute('aria-hidden', String(!loading));
        }
      }

      getWaveHeight() {
        return window.innerWidth >= BREAKPOINT_PX ? WAVE_HEIGHT_DESKTOP : WAVE_HEIGHT_MOBILE;
      }

      handleWaveResize() {
        if (!this.waveSurfer || !this.waveSurfer.getDecodedData()) return;

        const newHeight = this.getWaveHeight();
        const currentHeight = this.waveSurfer.options?.height;

        if (newHeight === currentHeight) return;

        this.waveSurfer.setOptions({ height: newHeight });

        this.waveSurfer.once('redrawcomplete', () => {
          if (!this.waveSurfer) return;
          this.updateProgress(this.waveSurfer.getCurrentTime());
          this.renderTimestamps();
        });
      }

      /* ---- Play / Stop ---- */
      safePlay() {
        if (!this.waveSurfer) return;
        const p = this.waveSurfer.play();
        if (p && typeof p.catch === 'function') {
          p.catch(() => {});
        }
      }

      handlePlayClick() {
        if (!this.waveSurfer || !this.isReady) return;

        if (this.isPlaying) {
          this.waveSurfer.pause();
          return;
        }

        const duration = this.waveSurfer.getDuration();
        const currentTime = this.waveSurfer.getCurrentTime();

        if (duration > 0 && currentTime >= duration - 0.1) {
          this.waveSurfer.seekTo(0);
        }

        this.safePlay();
      }

      setPlayingUI(playing) {
        if (this.playBtn) {
          this.playBtn.dataset.tdPlaying = String(playing);
          this.playBtn.setAttribute('aria-label', playing ? 'Stop audio' : 'Play audio');
        }
        this.updateTrackButtonLabels();
      }

      formatTrackTime(seconds) {
        const s = Math.max(0, typeof seconds === 'number' ? seconds : 0);
        const m = Math.floor(s / 60);
        const sec = Math.floor(s % 60);
        return m + ':' + (sec < 10 ? '0' : '') + sec;
      }

      updateProgress(currentTime) {
        if (!this.progressTrack) return;

        const duration = this.waveSurfer ? this.waveSurfer.getDuration() : 0;
        const time = typeof currentTime === 'number' ? currentTime : 0;
        const ratio = duration > 0 ? Math.max(0, Math.min(1, time / duration)) : 0;
        const pct = (ratio * 100) + '%';

        this.progressTrack.style.setProperty('--td-ac-progress', pct);
        this.progressTrack.setAttribute('aria-valuenow', Math.round(ratio * 100));

        if (this.trackTimerEls && this.trackTimerEls.length) {
          const timerText = this.formatTrackTime(time) + ' / ' + this.formatTrackTime(duration);
          this.trackTimerEls.forEach((el) => { el.textContent = timerText; });
        }
      }

      /* ---- Scrubbing ---- */
      handleProgressTrackKeydown(e) {
        if (!this.waveSurfer || !this.isReady) return;

        const duration = this.waveSurfer.getDuration();
        if (duration <= 0) return;

        const STEP = .15;
        let ratio = this.waveSurfer.getCurrentTime() / duration;

        switch (e.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            e.preventDefault();
            ratio -= STEP;
            break;
          case 'ArrowRight':
          case 'ArrowUp':
            e.preventDefault();
            ratio += STEP;
            break;
          case ' ':
          case 'Space':
            e.preventDefault();
            this.handlePlayClick();
            return;
          case 'Home':
            e.preventDefault();
            ratio = 0;
            break;
          case 'End':
            e.preventDefault();
            ratio = 1;
            break;
          default:
            return;
        }

        ratio = Math.max(0, Math.min(1, ratio));
        this.waveSurfer.seekTo(ratio);
        this.updateProgress(ratio * duration);
      }

      getScrubRatio(pointerEvent) {
        if (!this.progressTrack) return 0;

        const rect = this.progressTrack.getBoundingClientRect();
        const x = pointerEvent.clientX - rect.left;

        return Math.max(0, Math.min(1, x / rect.width));
      }

      handleScrubStart(e) {
        if (!this.waveSurfer || !this.isReady) return;

        e.preventDefault();
        this.isScrubbing = true;
        this.wasPlayingBeforeScrub = this.isPlaying;

        if (this.isPlaying) {
          this.waveSurfer.pause();
        }

        this.progressTrack.classList.add('td-audio-compare__progress-track--scrubbing');
        this.progressTrack.setPointerCapture(e.pointerId);

        document.addEventListener('pointermove', this.handleScrubMove);
        document.addEventListener('pointerup', this.handleScrubEnd);

        const ratio = this.getScrubRatio(e);
        this.waveSurfer.seekTo(ratio);
        this.updateProgress(ratio * this.waveSurfer.getDuration());
      }

      handleScrubMove(e) {
        if (!this.isScrubbing || !this.waveSurfer) return;

        const ratio = this.getScrubRatio(e);
        this.waveSurfer.seekTo(ratio);
        this.updateProgress(ratio * this.waveSurfer.getDuration());
      }

      handleScrubEnd(e) {
        if (!this.isScrubbing) return;

        document.removeEventListener('pointermove', this.handleScrubMove);
        document.removeEventListener('pointerup', this.handleScrubEnd);

        this.isScrubbing = false;

        if (this.progressTrack) {
          this.progressTrack.classList.remove('td-audio-compare__progress-track--scrubbing');

          try {
            this.progressTrack.releasePointerCapture(e.pointerId);
          } catch (_) {}
        }

        if (this.wasPlayingBeforeScrub && this.waveSurfer) {
          this.safePlay();
        }

        this.wasPlayingBeforeScrub = false;
      }

      /* ---- Load by voice/track selection ---- */
      loadAndPlay(autoPlay) {
        if (!this.WaveSurferLib) return;
        this.shouldAutoplayOnReady = !!autoPlay;
        this.createInstance();
      }

      /* ---- Timestamp rendering (dynamic per voice + track) ---- */
      renderTimestamps() {
        if (!this.timestampsContainer || !this.waveSurfer) return;

        this.timestampsContainer.replaceChildren();

        const timestamps = this.getActiveTimestamps();
        if (!timestamps.length) return;

        const duration = this.waveSurfer.getDuration();
        if (duration <= 0) return;

        const times = timestamps.map((ts) => parseFloat(ts.time) || 0);

        timestamps.forEach((ts, i) => {
          const start = times[i];
          const end = i < times.length - 1 ? times[i + 1] : duration;
          const widthPercent = ((end - start) / duration) * 100;

          const segment = document.createElement('span');
          segment.className = 'td-audio-compare__timestamp-segment';
          segment.style.width = widthPercent + '%';
          segment.style.setProperty('--td-ac-ts-color', ts.color || 'transparent');

          const label = document.createElement('span');
          label.className = 'td-audio-compare__timestamp-label';
          label.textContent = ts.title || '';

          segment.appendChild(label);
          this.timestampsContainer.appendChild(segment);
        });
      }

      /* ---- Helpers ---- */

      getComputedVar(name, fallback) {
        const value = getComputedStyle(this).getPropertyValue(name).trim();
        return value || fallback;
      }

      showMessage(text) {
        if (!this.messageEl) return;
        this.messageEl.hidden = false;
        this.messageEl.textContent = text;
        if (this.playerEl) {
          this.playerEl.classList.add('td-audio-compare__player--no-audio');
        }
      }

      clearMessage() {
        if (!this.messageEl) return;
        this.messageEl.hidden = true;
        this.messageEl.textContent = '';
        if (this.playerEl) {
          this.playerEl.classList.remove('td-audio-compare__player--no-audio');
        }
      }
    }

    if (!customElements.get(ELEMENT_NAME)) {
      customElements.define(ELEMENT_NAME, TDAudioCompare);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-hotspots-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-hot-spots-video')) {
    class TdHotSpotsVideo extends HTMLElement {
      constructor() {
        super();
        this.buttons = this.querySelectorAll('[data-button]');
        this.videoModal = null;
        this.videoHolder = null;
        this.currentVideoElement = null;
        this.modalCloseHandler = null;
        this.connectedCallback();
      }

      connectedCallback() {
        if (this.buttons.length) {
          this.buttons.forEach(btn => {
            const url = btn.dataset.videoUrl;
            const videoType = btn.dataset.videoType;
            if (!url || videoType !== 'shopify') return;
            
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              this.openShopifyVideo(url);
            });
          });
        }
      }

      initModal() {
        if (this.videoModal) {
          return true;
        }
        if (!window.theme || !window.theme.Modals) {
          return false;
        }

        const modalElement = document.getElementById('VideoModal');
        this.videoHolder = document.getElementById('VideoHolder');

        if (!modalElement && !videoHolder ) {
          return false;
        }

        this.videoModal = new window.theme.Modals('VideoModal', 'video-modal', {
          closeOffContentClick: true,
          bodyOpenClass: ['modal-open', 'video-modal-open'],
          solid: true
        });

        this.modalCloseHandler = () => {
          this.cleanupVideo();
        };
        document.addEventListener('modalClose.VideoModal', this.modalCloseHandler);

        return true;
      }

      cleanupVideo() {
        if (this.currentVideoElement) {
          if (this.currentVideoElement.pause) {
            this.currentVideoElement.pause();
          }
          this.currentVideoElement = null;
        }

        if (this.videoHolder) {
          this.videoHolder.innerHTML = '';
        }
      }

      createVideoElement(url) {
        const video = document.createElement('video');
        video.setAttribute('controls', '');
        video.setAttribute('autoplay', '');
        video.style.width = '100%';
        video.style.maxWidth = '100%';

        const source = document.createElement('source');
        source.setAttribute('src', url);
        source.setAttribute('type', 'video/mp4');

        video.appendChild(source);
        return video;
      }

      openShopifyVideo(url) {
        if (!url || typeof url !== 'string') {
          console.warn('TD Hotspots Video: Invalid video URL');
          return;
        }

        if (!this.initModal()) {
          return;
        }

        this.cleanupVideo();

        const videoElement = this.createVideoElement(url);
        this.videoHolder.appendChild(videoElement);
        this.currentVideoElement = videoElement;

        if (this.videoModal && typeof this.videoModal.open === 'function') {
          this.videoModal.open();
        }
      }

      disconnectedCallback() {
        if (this.modalCloseHandler) {
          document.removeEventListener('modalClose.VideoModal', this.modalCloseHandler);
          this.modalCloseHandler = null;
        }

        this.cleanupVideo();
      }
    }

    customElements.define('td-hot-spots-video', TdHotSpotsVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["td-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('td-quiz')) {
    class TDQuiz extends HTMLElement {
      constructor() {
        super();
        this.questionsContainer = null;
        this.resultsContainer = null;
        this.questionCheckboxes = [];
        this.results = [];
        this.resultsKeyToElement = new Map();
        this.statusRegion = null;
      }
  
      connectedCallback() {
        try {
          // Cache containers
          this.questionsContainer = this.querySelector('.td-quiz-questions');
          this.resultsContainer = this.querySelector('.td-quiz-results');

          if (!this.questionsContainer || !this.resultsContainer) {
            console.warn('[TDQuiz] Missing required containers');
            return;
          }

          // Collect inputs and results
          this.questionCheckboxes = Array.from(this.questionsContainer.querySelectorAll('input[type="checkbox"][name="td-quiz-question"]'));
          this.results = Array.from(this.resultsContainer.querySelectorAll('.td-quiz-result'));

          // Ensure a status element exists for announcements inside the single aria-live region
          this.#ensureStatusRegion();

          // Build lookup map for results by normalized key
          this.#buildResultsMap();

          // Initialize state
          this.#hideAllResults();
          this.#updateFromSelection();

          // Listen for changes
          this.#bindEventListeners();
        } catch (error) {
          console.error('[TDQuiz] Initialization error:', error);
        }
      }

      // Event binding kept separate for clarity and to follow project JS style
      #bindEventListeners() {
        const onChange = () => this.#updateFromSelection();
        this.questionCheckboxes.forEach((checkbox) => checkbox.addEventListener('change', onChange));
      }

      // Build an index of result combinations -> element
      #buildResultsMap() {
        this.resultsKeyToElement.clear();
        this.results.forEach((resultEl) => {
          const handles = this.#parseHandles(resultEl.getAttribute('data-products'));
          const key = this.#keyFromHandles(handles);
          if (!key) return;
          if (!this.resultsKeyToElement.has(key)) {
            this.resultsKeyToElement.set(key, resultEl);
          } else {
            // If there are duplicates, keep the first and warn in the console
            console.warn('[TDQuiz] Duplicate result combination detected for key:', key);
          }
        });
      }

      // Create or locate the status element used for announcing dynamic updates
      #ensureStatusRegion() {
        // Prefer reusing an existing status element to avoid duplicates
        const existing = this.resultsContainer.querySelector('.td-quiz__status');
        if (existing) {
          this.statusRegion = existing;
          return this.statusRegion;
        }

        const status = document.createElement('div');
        status.className = 'td-quiz__status visually-hidden';
        this.resultsContainer.prepend(status);
        this.statusRegion = status;
        return status;
      }

      // Update the visible result based on the combined selected product handles
      #updateFromSelection() {
        const selectedKey = this.#getSelectedKey();
        this.#hideAllResults();

        if (!selectedKey) {
          this.#announce('');
          return;
        }

        const match = this.resultsKeyToElement.get(selectedKey);
        if (match) {
          // Show first, then set active in next frame to allow CSS transitions
          match.removeAttribute('hidden');
          requestAnimationFrame(() => {
            match.setAttribute('data-active', 'true');
            this.#announce('Result updated');
          });
        } else {
          this.#announce('No matching result');
        }
      }

      // Compute the normalized key for the union of selected question handles
      #getSelectedKey() {
        const union = new Set();
        this.questionCheckboxes.forEach((checkbox) => {
          if (!checkbox.checked) return;
          const questionEl = checkbox.closest('.td-quiz-question');
          if (!questionEl) return;
          const handles = this.#parseHandles(questionEl.getAttribute('data-products'));
          handles.forEach((h) => union.add(h));
        });

        if (union.size === 0) return '';
        return this.#keyFromHandles(Array.from(union));
      }

      // Normalize a comma-separated string of handles into a sorted unique array
      #parseHandles(raw) {
        if (!raw) return [];
        return Array.from(
          new Set(
            raw
              .split(',')
              .map((s) => s.trim())
              .filter((s) => s.length > 0)
          )
        ).sort((a, b) => (a > b ? 1 : a < b ? -1 : 0));
      }

      // Create a canonical key from an array of handles where order does not matter
      #keyFromHandles(handlesArray) {
        if (!handlesArray || handlesArray.length === 0) return '';
        return handlesArray.slice().sort((a, b) => (a > b ? 1 : a < b ? -1 : 0)).join(',');
      }

      #hideAllResults() {
        this.results.forEach((el) => {
          el.setAttribute('hidden', '');
          el.removeAttribute('data-active');
        });
      }

      #announce(message) {
        if (!this.statusRegion) return;
        this.statusRegion.textContent = message;
      }
    }
  
    customElements.define('td-quiz', TDQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
